import React from "react";

// The red spec notes. The desktop section and the mobile device section render
// the same notes (only the font size differs), so each is written once here and
// the two sections can't drift apart.
const PAGE_HEADER_NOTE = {
  title: "Standard page header info:",
  items: [
    "Font family: Tahoma, Font size: 24px, Font color code: #003049, Bold: Yes.",
    "Space size ABOVE the page header: 16px. BELOW the page header: 16px.",
  ],
};

const REDUCED_PAGE_HEADER_NOTE = {
  title:
    "Reduced page header info (one use of this type of header is the side contact forms):",
  items: [
    "Font family: Tahoma, Font size: 20px, Font color code: #003049, Bold: Yes.",
    "Space size ABOVE the reduced page header: 16px. BELOW the reduced page header: 16px.",
  ],
};

const PARAGRAPH_HEADER_NOTE = {
  title: "Standard paragraph header info:",
  items: [
    "Font family: Tahoma, Font size: 18px, Font color code: #003049, Bold: Yes.",
    "Space size ABOVE the paragraph header: 0. BELOW the paragraph header: 16px.",
  ],
};

const BODY_TEXT_NOTE = {
  title: "Standard body text info:",
  items: [
    "Font family: Tahoma, Font size: 16px, Font color code: #003049, Bold: No.",
    "Space size ABOVE the body text: 0. BELOW the body text: 16px.",
  ],
};

const OTHER_NOTES = {
  title: "OTHER NOTES:",
  items: [
    'The logo, the "HOME" navigation button and the text on the page are aligned on the left wall (as seen on this page).',
    "The text on the page is boxed (as seen on this page).",
    "The selected navigation menu button is noticeably lighter or darker than the remaining navigation menu buttons.",
  ],
};

const BULLET_SPACING_NOTE = {
  title: "Bullet point spacing:",
  items: [
    "In order to adjust any bullet point spacing on any page, this can be done on the admin panel, the page content tab.",
  ],
};

// A title line followed by one bullet per item. last:mb-0 drops the 16px under
// the page's final note, so the box's 16px padding is all the space below it.
const SpecNote = ({ note, className = "" }) => (
  <div className={`mb-4 last:mb-0 text-red-700 leading-relaxed ${className}`.trim()}>
    <p>{note.title}</p>
    <ul className="list-disc pl-6">
      {note.items.map((item) => (
        <li key={item}>{item}</li>
      ))}
    </ul>
  </div>
);

const Test2 = () => {
  return (
    // Boxed like the COMMUNITY page (same border, corners and shadow). The box
    // sits on main's 16px gutter, so with its 1px border and 16px padding the
    // text starts 33px in from the container edge; Layout shifts the header's
    // logo and HOME button onto that same line for this page. flex-col keeps
    // each element's 16px margins from collapsing into each other.
    <div className="flex flex-col w-full bg-white rounded-lg border border-[#e5e7eb] shadow-md p-4">
      {/* No top margin: the box's 16px top padding is the standard space above
          a page header. */}
      <h1 className="text-2xl mb-4 font-bold text-[#003049]">
        A STANDARD PAGE HEADER
      </h1>
      <SpecNote note={PAGE_HEADER_NOTE} className="text-sm" />

      <h3 className="text-xl mt-4 mb-4 font-bold text-[#003049]">
        A REDUCED PAGE HEADER
      </h3>
      <SpecNote note={REDUCED_PAGE_HEADER_NOTE} className="text-sm" />

      <h2 className="text-[18px] font-bold text-[#003049] mb-4">
        A Standard Paragraph Header
      </h2>
      <SpecNote note={PARAGRAPH_HEADER_NOTE} className="text-sm" />

      <p className="text-[#003049] leading-relaxed mb-4 text-base">
        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed
        do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
        enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi
        ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit
        in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur
        sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt
        mollit anim id est laborum.
      </p>
      <SpecNote note={BODY_TEXT_NOTE} className="text-sm" />

      <SpecNote note={OTHER_NOTES} className="text-sm" />
      <SpecNote note={BULLET_SPACING_NOTE} className="text-sm" />

      <div className="border-b-[8px] border-red-600 border-dashed w-full mt-6 mb-2 mx-auto max-w-6xl flex items-center justify-center relative">
        <span className="absolute left-1/2 -translate-x-1/2 bg-white px-2 whitespace-nowrap sm:px-4 text-red-600 font-bold text-base sm:text-lg md:text-xl" style={{ top: '-10px' }}>
          MOBILE DEVICE SECTION
        </span>
      </div>

      {/* The divider's label hangs ~10px below the dashed line; mb-2 on the
          divider makes up for that, so this header's standard 16px top margin
          still reads as ~16px of space under the label. */}
      <h1 className="text-2xl mt-4 mb-4 font-bold text-[#003049]">
        A STANDARD PAGE HEADER
      </h1>
      <SpecNote note={PAGE_HEADER_NOTE} />

      <h3 className="text-xl mt-4 mb-4 font-bold text-[#003049]">
        A REDUCED PAGE HEADER
      </h3>
      <SpecNote note={REDUCED_PAGE_HEADER_NOTE} />

      <h2 className="text-lg font-bold text-[#003049] mb-4">
        A Standard Paragraph Header
      </h2>
      <SpecNote note={PARAGRAPH_HEADER_NOTE} />

      <p className="text-[#003049] leading-relaxed mb-4 text-base">
        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed
        do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
        enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi
        ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit
        in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur
        sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt
        mollit anim id est laborum.
      </p>
      <SpecNote note={BODY_TEXT_NOTE} />
    </div>
  );
};

export default Test2;
